import request from "@/utils/request";

// CRUD

export function register(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function fetchAdminInfo() {
  return request({
    url: '/admin',
    method: 'get'
  })
}

export function fetchAdminList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function getRoleListByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function login(username, password) {
  return request({
    url: '/admin/login',
    method: 'put',
    data: {
      username,
      password
    }
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/' + id,
    method: 'put',
    data: data
  })
}

export function updatePassword(data) {
  return request({
    url: '/admin/password',
    method: 'put',
    data: data
  })
}

export function updateAdminStatus(id, params) {
  return request({
    url: '/admin/status/' + id,
    method: 'put',
    params: params
  })
}

export function allocRole(id, data) {
  return request({
    url: '/admin/role/' + id,
    method: 'put',
    data: data
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/admin.js